import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';

import { useTranslation } from '@lt/localization';
import Icon from 'src/components/Icon';
import { getTouristsCount } from 'checkout/store/selectors/package';
import { toggleFlightClassAction } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/slice';
import { getUpgradedFlight } from 'checkout/store/selectors/extras';
import {
  getSelectedFlightData,
  getOriginalFlightId,
} from 'checkout/store/selectors/order';
import FlightsPropTypes from '../../../../proptypes/flights';
import { baseCls } from '../../../../components/Flights/FlightsItemContainer/components/FlightsItem';
import FlightClassUpgradeInfo from '../../../../components/Flights/FlightClassUpgradeInfo';

const UpgradeFlightSummary = ({
  businessFlightData,
  originalFlight,
  toggleFlightClass,
  currentFlight,
  touristsCount,
}) => {
  const { t } = useTranslation();
  const extraPrice =
    businessFlightData.back.fuel_charge - currentFlight.back.fuel_charge;
  // LT-38561: Удалить запись replay session на чекауте (https://tracker.yandex.ru/LT-38561)
  // Инициируем кастомное событие для отправки сессии в сентри
  const onFlightSelect = new CustomEvent('flightSelect');
  return (
    <div className={`${baseCls}__summary`}>
      {originalFlight ? (
        <div className="flight-upgraded">
          <div className="flight-upgraded__containner">
            <div className="flight-upgraded__circle">
              <Icon type="sign_additional" />
            </div>
            <div className="flight-upgraded__content">
              <Icon type="success_additional" />
              <div className="upgrade-flight-label">
                <div>{t('checkout.upgradeFlightClass.сongratulations')}!</div>
                <div>{t('checkout.upgradeFlightClass.label')}</div>
              </div>
            </div>
          </div>
          <Button
            functional
            className="restore-economy-flight"
            onClick={() => {
              toggleFlightClass({
                flight_pair_id: originalFlight,
                originalFlight: null,
              });
              // LT-38561: Удалить запись replay session на чекауте (https://tracker.yandex.ru/LT-38561)
              document.dispatchEvent(onFlightSelect);
            }}
          >
            {t('checkout.upgradeFlightClass.restoreEconomy')}
          </Button>
        </div>
      ) : (
        <>
          <FlightClassUpgradeInfo
            extraPrice={extraPrice}
            touristsCount={touristsCount}
          />
          <Button
            primary
            size="flex"
            className={`${baseCls}__submit`}
            onClick={() => {
              toggleFlightClass({
                flight_pair_id: businessFlightData.back.flight_pair_id,
                originalFlight: currentFlight.back.flight_pair_id,
              });
              // LT-38561: Удалить запись replay session на чекауте (https://tracker.yandex.ru/LT-38561)
              document.dispatchEvent(onFlightSelect);
            }}
          >
            <div className="upgrade-flight-label">
              <div>{t('checkout.upgradeFlightClass.fly')}</div>
              <div>{t('checkout.upgradeFlightClass.business')}</div>
            </div>
          </Button>
        </>
      )}
    </div>
  );
};
UpgradeFlightSummary.propTypes = {
  businessFlightData: FlightsPropTypes.item.isRequired,
  currentFlight: FlightsPropTypes.item.isRequired,
  touristsCount: PropTypes.number.isRequired,
  toggleFlightClass: PropTypes.func.isRequired,
  // Идентификатор выбранного на первом шаге эконом-рейса
  originalFlight: PropTypes.string,
};
UpgradeFlightSummary.defaultProps = {
  originalFlight: null,
};

const mapStateToProps = (state) => ({
  flightData: getUpgradedFlight(state),
  currentFlight: getSelectedFlightData(state),
  touristsCount: getTouristsCount(state),
  originalFlight: getOriginalFlightId(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleFlightClass: (id) => dispatch(toggleFlightClassAction(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpgradeFlightSummary);
